import { render, staticRenderFns } from "./HistoricalLocation.vue?vue&type=template&id=22245682&scoped=true"
import script from "./HistoricalLocation.vue?vue&type=script&lang=js"
export * from "./HistoricalLocation.vue?vue&type=script&lang=js"
import style0 from "./HistoricalLocation.vue?vue&type=style&index=0&id=22245682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22245682",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TDRoutesOnMap: require('/home/vsts/work/1/s/components/TDRoutesOnMap.vue').default,GlobalDrawerList: require('/home/vsts/work/1/s/components/global/DrawerList.vue').default})
